/**
 * FooterThumbnailLocker Component - Created by david on 06/04/18.
 */
import * as React from 'react'
import messages from './messages'
import { RevenueRecord } from '../../types/common'
import {
  Footer,
  Description,
  DescriptionSection,
  LeftDescription,
  AddToStoreActionButton,
  HyperLinkCode,
  DesignName,
  ButtonsContainer
} from './styledComponents'

interface Props {
  shortId?: string
  name: string
  description: string
  date: string
  code: string
  zipFile?: string
  isPrivate: boolean
  addToCartButton: React.ReactNode
  canShare: boolean
  showDelete: boolean
  showAddToStoreButton?: boolean
  proDesign?: boolean
  proCertified?: boolean
  revenue?: RevenueRecord[]
  designLabView?: boolean
  onPressPrivate: (shortId: string, isPrivate: boolean) => void
  onPressDelete: (shortId: string, name: string) => void
  formatMessage: (messageDescriptor: any) => string
  onPressRename: (shortId: string, name: string) => void
  openAddStore: () => void
  setShare: () => void
  goToProductPage: () => void
}

const FooterThumbnailLocker = ({
  name,
  description,
  code,
  formatMessage,
  addToCartButton,
  showAddToStoreButton,
  openAddStore,
  goToProductPage,
  designLabView
}: Props) => {
  // Refactoring SHA codes: 77f1a4f10

  return (
    <Footer>
      {!designLabView &&
        <ButtonsContainer>
          {addToCartButton}
          {showAddToStoreButton &&
            <AddToStoreActionButton onClick={openAddStore}>
              {formatMessage(messages.addToStore)}
            </AddToStoreActionButton>
          }
        </ButtonsContainer>
      }
      <DescriptionSection>
        <LeftDescription>
          <DesignName>
            {name}
          </DesignName>
          <Description>
            {description}
          </Description>
          <HyperLinkCode onClick={goToProductPage}>
            {code}
          </HyperLinkCode>
        </LeftDescription>
      </DescriptionSection>
    </Footer>
  )
}

export default FooterThumbnailLocker



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterThumbnailLocker/index.tsx